<template>
  <ResourceView :entityId="$route.params.supplierId" entityClass="Supplier">
  </ResourceView>
</template>


<script>
import ResourceView from "@/views/admin/machines/ResourceView.vue";

export default {
  name: "ViewSupplierResources",
  components: {
    ResourceView,
  },

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style scoped></style>